import '@siemens/ix/dist/siemens-ix/siemens-ix.css';

import './styles/brand.css';

import { IxApplicationContext } from '@siemens/ix-react';
import { createRoot } from 'react-dom/client';

import { getBffTokenSilent } from './api/token.js';
import { App } from './App.js';
import { reportClientError, setClientErrorTokenProvider } from './telemetry/reportClientError.js';

// POST /v1/client-errors is JWT-protected, so the reporter needs a way to get a
// token. Injected here rather than imported inside the telemetry module to
// avoid an import cycle (auth/msalConfig.ts reports MSAL failures through it).
setClientErrorTokenProvider(getBffTokenSilent);

window.addEventListener('error', (e) => {
  reportClientError('uncaught_error', e.message, e.error instanceof Error ? e.error.stack : undefined);
});

window.addEventListener('unhandledrejection', (e) => {
  const reason = e.reason as unknown;
  reportClientError(
    'unhandled_rejection',
    reason instanceof Error ? reason.message : String(reason),
    reason instanceof Error ? reason.stack : undefined,
  );
});

const appEl = document.getElementById('app');
if (!appEl) throw new Error('No #app element found in document');

const root = createRoot(appEl);
root.render(
  <IxApplicationContext>
    <App />
  </IxApplicationContext>,
);
